// Synchronise les cartes composants du coffret avec la variante sélectionnée
// du bundle. S'appuie sur le pub/sub du thème (PUB_SUB_EVENTS.variantChange,
// publié par global.js:1366-1369 avec event.data = { sectionId, optionValueIds,
// variantId } — pas d'objet variant complet dans le payload). On résout donc
// variantId → variante via la liste préchargée en data-variants (même pattern
// que assets/atc-total-price.js). Dégradation sans JS : le Liquid rend l'état
// de la variante par défaut.
if (!customElements.get('famille-bundle-sync')) {
  customElements.define(
    'famille-bundle-sync',
    class FamilleBundleSync extends HTMLElement {
      connectedCallback() {
        try {
          this.productOptions = JSON.parse(this.getAttribute('data-product-options') || '[]');
        } catch (e) {
          this.productOptions = [];
        }
        this.sectionId = this.getAttribute('data-section-id') || '';
        try {
          this.variants = JSON.parse(this.getAttribute('data-variants') || '[]');
        } catch (e) {
          this.variants = [];
        }
        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
          this.unsubscribe = subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
            const sid = event?.data?.sectionId;
            if (sid && String(sid) !== String(this.sectionId)) return;
            const vid = event?.data?.variantId;
            const variant = this.variants.find((v) => String(v.id) === String(vid));
            if (variant) this.sync(variant);
          });
        }
      }
      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }
      sync(variant) {
        this.querySelectorAll('.flx-bundle-card--syncable').forEach((card) => {
          const optionName = card.getAttribute('data-sync-option');
          const map = JSON.parse(card.getAttribute('data-sync-map') || '{}');
          const optionIndex = this.productOptions.indexOf(optionName);
          if (optionIndex === -1) return;
          const value = variant.options[optionIndex];
          const entry = map[value];
          if (!entry) return;
          const img = card.querySelector('.flx-bundle-card__img img');
          if (img && entry.img) img.src = entry.img;
          const meta = card.querySelector('.flx-bundle-card__meta');
          if (meta && entry.label) meta.textContent = entry.label;
        });
      }
    }
  );
}
